"use strict";
exports.__esModule = true;
var regex = /^(?:1|t(?:rue)?|y(?:es)?|on|ok(?:ay)?)$/;
function default_1(s) {
    return regex.test(s.trim().toLowerCase());
}
exports["default"] = default_1;
;
